/* Rampoos home — all interactive behaviour, each block guarded so removing
   a section doesn't break the others. */

/* ---------- Hero slider ---------- */
(function(){
  const slides = document.querySelectorAll('.hero .slide');
  if (slides.length === 0) return;
  const dots = document.querySelectorAll('.hero .slider-dots .dot');
  const counterCurr = document.querySelector('.hero .slide-counter .curr');
  const progressBar = document.getElementById('progressBar');
  const prevBtn = document.getElementById('prevBtn');
  const nextBtn = document.getElementById('nextBtn');
  const hero = document.querySelector('.hero');
  const slideDuration = 6000;
  let currentSlide = 0;
  let slideTimer = null;
  let progressTimer = null;
  let progressStart = 0;

  function goToSlide(index){
    slides[currentSlide].classList.remove('active');
    if (dots[currentSlide]) dots[currentSlide].classList.remove('active');
    currentSlide = (index + slides.length) % slides.length;
    slides[currentSlide].classList.add('active');
    if (dots[currentSlide]) dots[currentSlide].classList.add('active');
    if (counterCurr) counterCurr.textContent = String(currentSlide + 1).padStart(2, '0');
    restartTimer();
  }
  function nextSlide(){ goToSlide(currentSlide + 1); }
  function prevSlide(){ goToSlide(currentSlide - 1); }

  function restartTimer(){
    clearInterval(slideTimer); clearInterval(progressTimer);
    progressStart = Date.now();
    if (progressBar) progressBar.style.width = '0%';
    slideTimer = setTimeout(nextSlide, slideDuration);
    progressTimer = setInterval(() => {
      const elapsed = Date.now() - progressStart;
      const pct = Math.min((elapsed / slideDuration) * 100, 100);
      if (progressBar) progressBar.style.width = pct + '%';
    }, 50);
  }

  dots.forEach((dot, i) => dot.addEventListener('click', () => goToSlide(i)));
  if (prevBtn) prevBtn.addEventListener('click', prevSlide);
  if (nextBtn) nextBtn.addEventListener('click', nextSlide);

  if (hero) {
    hero.addEventListener('mouseenter', () => { clearInterval(slideTimer); clearInterval(progressTimer); });
    hero.addEventListener('mouseleave', restartTimer);

    let touchStartX = 0;
    hero.addEventListener('touchstart', (e) => { touchStartX = e.touches[0].clientX; }, {passive: true});
    hero.addEventListener('touchend', (e) => {
      const dx = e.changedTouches[0].clientX - touchStartX;
      if(Math.abs(dx) > 50){ dx > 0 ? prevSlide() : nextSlide(); }
    }, {passive: true});
  }

  document.addEventListener('keydown', (e) => {
    if(e.key === 'ArrowLeft') prevSlide();
    if(e.key === 'ArrowRight') nextSlide();
  });

  if (slides.length > 1) restartTimer();
})();

/* ---------- Scroll reveal ---------- */
(function(){
  if (!('IntersectionObserver' in window)) return;
  const io = new IntersectionObserver((entries) => {
    entries.forEach(e => {
      if(e.isIntersecting){ e.target.classList.add('visible'); io.unobserve(e.target); }
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -60px 0px' });
  document.querySelectorAll('.reveal').forEach(el => io.observe(el));
})();

/* ---------- Size picker ---------- */
(function(){
  document.querySelectorAll('.size-picker').forEach(picker => {
    picker.addEventListener('click', (e) => {
      if(e.target.classList.contains('size-btn')){
        picker.querySelectorAll('.size-btn').forEach(b => b.classList.remove('active'));
        e.target.classList.add('active');
      }
    });
  });
})();

/* ---------- Add to cart (visual only — real cart handled by Shopify form) ---------- */
(function(){
  const cartCount = document.querySelector('.cart-count');
  if (!cartCount) return;
  document.querySelectorAll('.btn-primary').forEach(btn => {
    if(btn.textContent.trim().startsWith('Add to cart')){
      btn.addEventListener('click', (e) => {
        const n = parseInt(cartCount.textContent || '0', 10) + 1;
        cartCount.textContent = n;
        const orig = btn.innerHTML;
        btn.innerHTML = 'Added ✓';
        setTimeout(() => { btn.innerHTML = orig; }, 1500);
      });
    }
  });
})();

/* ---------- Testimonial rotation ---------- */
(function(){
  const testimonialsRoot = document.querySelector('.testimonial');
  if (!testimonialsRoot) return;
  const dataNodes = testimonialsRoot.querySelectorAll('[data-testimonial]');
  const testimonials = [];
  dataNodes.forEach(n => testimonials.push({
    q:      n.dataset.quote  || '',
    who:    n.dataset.who    || '',
    where:  n.dataset.where  || '',
    avatar: n.dataset.avatar || ''
  }));
  if (testimonials.length === 0) return;
  const bq      = testimonialsRoot.querySelector('blockquote');
  const tName   = testimonialsRoot.querySelector('#testimonialName');
  const tWhere  = testimonialsRoot.querySelector('#testimonialWhere');
  const tAvatar = testimonialsRoot.querySelector('#testimonialAvatar');
  const tdots   = testimonialsRoot.querySelectorAll('.dots-t span');
  let ti = 0;
  tdots.forEach((d, i) => d.addEventListener('click', () => swap(i)));
  function swap(i){
    ti = i;
    const t = testimonials[i];
    if (bq)      bq.innerHTML       = t.q;
    if (tName)   tName.textContent  = t.who;
    if (tWhere)  tWhere.textContent = t.where;
    if (tAvatar) { tAvatar.src = t.avatar; tAvatar.alt = t.who; }
    tdots.forEach((d, j) => d.classList.toggle('active', j === i));
  }
  if (testimonials.length > 1) {
    setInterval(() => swap((ti + 1) % testimonials.length), 6500);
  }
})();

/* ---------- Newsletter (visual-only submit; the real form is a Shopify contact form) ---------- */
(function(){
  document.querySelectorAll('.newsletter-form').forEach(form => {
    form.addEventListener('submit', (e) => {
      // Real Shopify forms have an action starting with "/contact" — let them submit
      const action = form.getAttribute('action') || '';
      if (action.startsWith('/contact') || form.hasAttribute('data-shopify')) return;
      e.preventDefault();
      const btn = form.querySelector('button');
      const inp = form.querySelector('input[type="email"]');
      if (btn) btn.textContent = 'Subscribed ✓';
      if (inp) inp.value = '';
    });
  });
})();
